import React, { Fragment, useEffect, useRef, useState } from "react";
import {
    AppBar,
    Grid,
    TextField,
    Box,
    Paper,
    Tab,
    Tabs,
    Typography,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    withStyles,
    Button,
} from "@material-ui/core";
import PropTypes from "prop-types";
import HttpService from "../../services/httpService";
import { setLoading } from "../../redux/actions/appAction";
import { connect, useSelector } from "react-redux";
import { Modal } from "antd";
import moment from "moment";
import { CSVLink } from "react-csv";
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import {
    CONST_USER_ID,
    PalaPrasanthKumarId,
    PalisettiTejaId,
    ROLENAME,
    SriKrishnaId,
    ThirumaleshId,
} from "../../utils";
import { Link } from 'react-router-dom'
import { DownloadOutlined } from '@ant-design/icons';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        "& > *": {
            margin: theme.spacing(1),
        },
    },
    // table: {
    // 	maxWidth:"67vw",
    // },
    tablecontainer: {
        display: "flex",
        margin: "25px",
    },
    customTableContainer: {
        overflowX: "initial",
    },
    tableform: {
        display: "flex",
        maxWidth: "68vw",
        textAlign: "center"
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 400,
    },
    clickableTableCell: {
        cursor: "pointer",
        textDecoration: "underline",
        color: "blue",
    },
    normalTableCell: {
        color: "black",
        "&:hover": {
            cursor: "pointer",
            color: "blue", // you can change the color when hovering here
            textDecoration: "underline",
        },
    },
    tableCell: {
        color: "blue",
        cursor: "pointer",
        textDecoration: "underline",

        // Changing color, cursor and textDecoration on hovering
        // "&:hover": {
        // 	cursor: "pointer",
        // 	color: "blue", // you can change the color when hovering here
        // 	textDecoration: "underline",
        // },
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    narrowTab: {
        minWidth: "fit-content", // Adjust the width as needed
        // width:"fit-content",
        width: 65,
    },
    margin: {
        margin: theme.spacing(1),
    },
    activeButton: {
        backgroundColor: "#F50057 !important",
        color: "white !important",
        transition: "background-color 0.3s, color 0.3s",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
      },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500",
        width: "102%"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const SummaryOfCompletion = (props) => {
    const classes = useStyles();
    const [value, setValue] = useState("");
    const { userDetails } = useSelector((state) => state.user);
    const [materialDeliveryData, setMaterialDeliveryData] = useState([]);
    const [underExecutionData, setUnderExecutionData] = useState([]);
    const [projectCompetionData, setProjectCompletionData] = useState([]);
    const [completedMwpData, setCompletedMwpData] = useState([]);
    const [factoryStageData, setFactoryStageData] = useState([]);
    const [factoryDataForOps1, setFactoryDataForOps1] = useState([]);
    const [completedProjectData, setCompletedProjectData] = useState([]);
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [detailDataArray, setDetailDataArray] = useState([]);
    const [title, setTitle] = useState("Dummy Title");
    const [csvData, setCsvData] = useState([]);
    const [summaryOfCompletionTableCsvData, setSummaryOfCompletionTableCsvData] = useState([]);
    const summaryOfCompletionTableCsvButtonRef = useRef(null);
    const [triggerDownload, setTriggerDownload] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const csvButtonRef = useRef(null);
    const [ShowDesignSignOffRevokeDate, setShowDesignSignOffRevokeDate] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']

    let includeExperienceCenter = detailDataArray.some(item => item.experienceCenterName !== "" && item.experienceCenterName !== null && item.experienceCenterName !== undefined);
    let includeFactoryBomCompletedDate = detailDataArray.some(item => item.factoryBomCompletedDate !== "" && item.factoryBomCompletedDate !== null && item.factoryBomCompletedDate !== undefined);
    let includeRevocationDate = detailDataArray.some(item => item.designSignoffRevokeDate !== "" && item.designSignoffRevokeDate !== null && item.designSignoffRevokeDate !== undefined);
    let includedesignerAndAdmName = detailDataArray.some(item => item.designManagerName !== "" && item.designManagerName !== null && item.designManagerName !== undefined);
    let includeChmName = detailDataArray.some(item => item.chmUserName !== "" && item.chmUserName !== null && item.chmUserName !== undefined);
    let includeCustomerName = detailDataArray.some(item => item.customerName !== "" && item.customerName !== null && item.customerName !== undefined);
    let includeCustomerAddress = detailDataArray.some(item => item.customerAddress !== "" && item.customerAddress !== null && item.customerAddress !== undefined);
    let includeContractQualityControlApproved = detailDataArray.some(item => item.contractQualityControlApproved !== "" && item.contractQualityControlApproved !== null && item.contractQualityControlApproved !== undefined);
    let includeContractQCManagerApproved = detailDataArray.some(item => item.contractQCManagerApproved !== "" && item.contractQCManagerApproved !== null && item.contractQCManagerApproved !== undefined);
    let includeContractDesignManagerApproved = detailDataArray.some(item => item.contractDesignManagerApproved !== "" && item.contractDesignManagerApproved !== null && item.contractDesignManagerApproved !== undefined);
    let includeContractCustomerApproved = detailDataArray.some(item => item.contractCustomerApproved !== "" && item.contractCustomerApproved !== null && item.contractCustomerApproved !== undefined);
    let includeContractFinanceApproved = detailDataArray.some(item => item.contractFinanceApproved !== "" && item.contractFinanceApproved !== null && item.contractFinanceApproved !== undefined);
    let includeMaterialDeliveryDate = detailDataArray.some(item => item.materialDispatchedDate !== "" && item.materialDispatchedDate !== null && item.materialDispatchedDate !== undefined);
    let includeActualCompletionDate = detailDataArray.some(item => item.executionCompletionDate !== "" && item.executionCompletionDate !== null && item.executionCompletionDate !== undefined);
    let includeExecutionMWPDate = detailDataArray.some(item => item.executionMWPDate !== "" && item.executionMWPDate !== null && item.executionMWPDate !== undefined);

    // Headers for csv file
    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNo", label: "Lead No" },
        { key: "currentStage", label: "Stage" },
        { key: "departmentName", label: "Department" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "cityName", label: "City Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designSignOffDate", label: "Design Sign-Off Date" },
    ];

    if (includeExperienceCenter) {
        headers.push({ key: "experienceCenter", label: "Experience Center" });
    }
    if (includeFactoryBomCompletedDate) {
        headers.push({ key: "factoryBomCompletedDate", label: "Factory Assignment Date" });
    }
    if (includeRevocationDate) {
        headers.push({ key: "revocationDate", label: "Design-Hold Revoke Date" });
    }
    if (includedesignerAndAdmName) {
        headers.push({ key: "designerAndAdmName", label: "Designer/ADM name" });
    }
    if (includeChmName) {
        headers.push({ key: "chmName", label: "CHM Name" });
    }
    if (includeCustomerName) {
        headers.push({ key: "customerName", label: "Customer name" });
    }
    if (includeContractQualityControlApproved) {
        headers.push({ key: "contractQualityControlApproved", label: "QC Approval" });
    }
    if (includeContractQCManagerApproved) {
        headers.push({ key: "contractQCManagerApproved", label: "QC Manager Approval" });
    }
    if (includeContractDesignManagerApproved) {
        headers.push({ key: "contractDesignManagerApproved", label: "ADM Approval" });
    }
    if (includeContractCustomerApproved) {
        headers.push({ key: "contractCustomerApproved", label: "Customer Approval" });
    }
    if (includeContractFinanceApproved) {
        headers.push({ key: "contractFinanceApproved", label: "Finance Approval" });
    }
    if (includeMaterialDeliveryDate) {
        headers.push({ key: "materialDeliveryDate", label: "Material Delivery Date" });
    }
    if (includeActualCompletionDate) {
        headers.push({ key: "actualCompletionDate", label: "Actual Completion Date" });
    }
    if (includeExecutionMWPDate) {
        headers.push({ key: "executionMWPDate", label: "MWP Completion Date" });
    }
    if (includeCustomerAddress) {
        headers.push({ key: "apartmentName", label: "Apartment Name" });
    }

    const formatToLakhs = (value) => {
        const valueInLakhs = value / 100000;
        return valueInLakhs.toLocaleString("en-IN", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });
    };
    // Function to handle tab changes
    const handleChange = (newValue) => {
        setValue(newValue);
        setStartDate("");
        setEndDate("");
        setSearchInput("")
        setSelectedSearchType("")
    };

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleSearch = async (diffValue) => {
        getProjectCompletionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };

    // Function to get Project's count for ops-1 tab
    const getProjectCompletionDataCityWise = async (startDate, endDate, selectedSearchType, searchInput) => {
        props.setLoading(true);
        let obj = {
            startDate: startDate,
            endDate: endDate,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        try {
            const response = await HttpService.getProjectCompletionDataCityWise(obj);
            setProjectCompletionData(response.data);
        } catch (error) {
            console.log("Error ->", error);
        }
        props.setLoading(false);
    };


    // Function to show Details
    const showDetailedModalHandler = (data, text) => {
        try {
            let call = data.map((el) => el.currentStage);
            let checkStage = call.every((el) => el === 'Design Sign-off HOLD');
            setShowDesignSignOffRevokeDate(checkStage)
            setShowDetailedModal(true);
            setTitle(text);
            setDetailDataArray(data);
        } catch (error) {
            console.log("Error - ", error);
        }
    };

    // Function to download csv
    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < detailDataArray.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: detailDataArray[i]?.erpProjectNo || "N/A",
                    leadNo: detailDataArray[i]?.lead_no,
                    currentStage: detailDataArray[i]?.currentStage,
                    departmentName: detailDataArray[i]?.departmentName,
                    totalValue: detailDataArray[i]?.grandTotal / 1.18 || "-",
                    cityName: detailDataArray[i]?.cityName,
                    salesWonDate: detailDataArray[i]?.leadWonDate
                        ? moment(detailDataArray[i]?.leadWonDate).format("DD-MM-YYYY")
                        : "-",
                    designSignOffDate: detailDataArray[i]?.customerDesignSignOffDate
                        ? moment(detailDataArray[i]?.customerDesignSignOffDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    materialDeliveryDate: detailDataArray[i]?.materialDispatchedDate
                        ? moment(detailDataArray[i]?.materialDispatchedDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    actualCompletionDate: detailDataArray[i]?.executionCompletionDate
                        ? moment(detailDataArray[i]?.executionCompletionDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    executionMWPDate: detailDataArray[i]?.executionMWPDate
                        ? moment(detailDataArray[i]?.executionMWPDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    designerAndAdmName: detailDataArray[i]?.designUserName + " / " + detailDataArray[i]?.designManagerName,
                    apartmentName: detailDataArray[i]?.customerAddress,
                    customerName: detailDataArray[i]?.customerName,
                    chmName: detailDataArray[i]?.chmUserName,
                    factoryBomCompletedDate: detailDataArray[i]?.factoryBomCompletedDate
                        ? moment(detailDataArray[i]?.factoryBomCompletedDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    revocationDate: detailDataArray[i]?.designSignoffRevokeDate
                        ? moment(detailDataArray[i]?.designSignoffRevokeDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    experienceCenter: detailDataArray[i]?.experienceCenterName,
                    contractQualityControlApproved: detailDataArray[i]?.contractQualityControlApproved,
                    contractQCManagerApproved: detailDataArray[i]?.contractQCManagerApproved,
                    contractDesignManagerApproved: detailDataArray[i]?.contractDesignManagerApproved,
                    contractCustomerApproved: detailDataArray[i]?.contractCustomerApproved,
                    contractFinanceApproved: detailDataArray[i]?.contractFinanceApproved,
                };
                csvArray.push(obj);
                // obj = {
                //     serialNo: "",
                //     projectCode: "",
                //     leadNo: "",
                //     totalValue: "",
                //     cityName: "",
                //     salesWonDate: "",
                //     designSignOffDate: "",
                //     materialDeliveryDate: "",
                //     actualCompletionDate: "",
                //     revocationDate: "",
                //     factoryBomCompletedDate: "",
                //     experienceCenter: "",
                // };
                // csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    // Function verify User
    // const verifyDataVisibilityAccess = () => {
    // 	if (
    // 		findMatchingUser(userDetails?._id) ||
    // 		userDetails?.roles.find(
    // 			(role) => role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.DataAnalyst || role.name === ROLENAME.FinanceManager
    // 		)
    // 	) {
    // 		setValue("Summary of Delivery");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) => role.name === ROLENAME.SeniorOperationManager || role.name === ROLENAME.Admin
    // 		)
    // 	) {
    // 		setValue("Ops-1");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) => role.name === ROLENAME.FactoryManager
    // 		) &&
    // 		userDetails?._id.toString() !== ThirumaleshId
    // 	) {
    // 		setValue("Ops-2 (Factory)");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) =>
    // 				role.name === ROLENAME.DGM_Ops ||
    // 				role.name === ROLENAME.Execution_Manager
    // 		) ||
    // 		userDetails?._id === SriKrishnaId
    // 	) {
    // 		setValue("Ops-3 (Execution)");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) =>
    // 				role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.ExecutionUser
    // 		) ||
    // 		userDetails?._id === PalisettiTejaId ||
    // 		userDetails?._id === PalaPrasanthKumarId
    // 	) {
    // 		setValue("Ops-3 (MWP)");
    // 	}
    // };

    const dateFilterHandler = () => {
        getProjectCompletionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    };

    const clearDateFilter = () => {
        setStartDate("");
        setEndDate("");
        setSearchInput("")
        setSelectedSearchType("")
        getProjectCompletionDataCityWise("", "", "", "");
    };

    // Trigger CSV download when data is ready
    useEffect(() => {
        if (triggerDownload && summaryOfCompletionTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (summaryOfCompletionTableCsvButtonRef.current?.link) {
                    try {
                        summaryOfCompletionTableCsvButtonRef.current.link.click();
                    } catch (error) {
                        console.error("Error triggering CSV download:", error);
                        props?.setSnackInfo("Error downloading CSV", "error");
                    }
                    setTriggerDownload(false);
                } else {
                    // Retry if link is not ready
                    setTimeout(() => {
                        if (summaryOfCompletionTableCsvButtonRef.current?.link) {
                            summaryOfCompletionTableCsvButtonRef.current.link.click();
                            setTriggerDownload(false);
                        }
                    }, 200);
                }
            }, 300);
            
            return () => clearTimeout(timer);
        }
    }, [triggerDownload, summaryOfCompletionTableCsvData]);

    // Function to generate CSV data for summary of completion table
    const generateSummaryOfCompletionTableCsvData = () => {
        try {
            if (!projectCompetionData || projectCompetionData.length === 0 || !projectCompetionData[0]?.monthlyData) {
                return [];
            }

            const csvRows = [];

            // Build header row - match table structure exactly
            const headerRow = {
                "Project Completion Month": ""
            };

            // Add location columns
            projectCompetionData.forEach((el) => {
                if (el?.locationDetail?.locationName) {
                    headerRow[el.locationDetail.locationName] = "";
                }
            });
            csvRows.push(headerRow);

            // Add data rows for each month
            projectCompetionData[0].monthlyData.forEach((monthEl) => {
                const row = {
                    "Project Completion Month": monthEl?.mmyyyy === "Grand Total" 
                        ? monthEl?.mmyyyy 
                        : `${monthEl?.mmyyyy.slice(0, 3)}-${monthEl?.mmyyyy.slice(-2)}`
                };

                // Add value for each location
                projectCompetionData.forEach((data) => {
                    const monthlyData = data?.monthlyData?.find(
                        (md) => md?.mmyyyy === monthEl?.mmyyyy
                    );
                    if (data?.locationDetail?.locationName) {
                        row[data.locationDetail.locationName] = monthlyData?.value || 0;
                    }
                });

                csvRows.push(row);
            });

            return csvRows;
        } catch (error) {
            console.error("Error generating summary of completion table CSV:", error);
            return [];
        }
    };

    useEffect(() => {
        // verifyDataVisibilityAccess();
        getProjectCompletionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    }, []);
    return (
        <Fragment>
            <Fragment>
                {/* Date filter component */}
                <Paper style={{ padding: 10, marginLeft: 25 }}>
                    <Grid
                        container
                        style={{ display: "flex", alignItems: "center" }}
                    >
                        <Grid item md={3} xs={12}>
                            <TextField
                                id="date"
                                name="startDate"
                                label="From Date"
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item md={1} xs={12}></Grid>
                        <Grid item md={3} xs={12}>
                            <TextField
                                id="date"
                                name="endDate"
                                label="End Date"
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item md={3} xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={!startDate || !endDate}
                                onClick={dateFilterHandler}
                                style={{ marginLeft: 10 }}
                                className={startDate && endDate?classes.submitButton:""}
                            >
                                Submit
                            </Button>
                        </Grid>
                        <Grid item md={2} xs={12}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={clearDateFilter}
                            >
                                Clear Filter
                            </Button>
                        </Grid>
                    </Grid>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                        {/* Search Type Dropdown */}
                        <TextField
                            select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedSearchType}
                            label="Search Type"
                            name="searchType"
                            onChange={(e) => handleSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: '30%', marginRight: '2%' }}
                            size="small"
                        >
                            {searchTypes && searchTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>{el}</MenuItem>
                            ))}
                        </TextField>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchInput}
                            onChange={(e) => { setSearchInput(e.target.value) }}
                            onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                            variant="outlined"
                            style={{ width: '80%' }}
                        />

                        {/* Search Button */}
                        <Button
                            disabled={!selectedSearchType || !searchInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ alignSelf: "center", marginLeft: 20 }}
                            className={classes.leadSearchButton}
                            onClick={() => handleSearch(searchInput.toUpperCase())}
                        >
                            Search
                        </Button>

                        {/* Clear Filter Button */}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            style={{ marginLeft: 10 }}
                            className={classes.leadClearButton}
                            onClick={clearDateFilter}
                        >
                            Clear Filter
                        </Button>
                    </div>
                </Paper>

                {/* Data Table */}
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px', marginLeft: 25 }}>
                    <CSVLink
                        data={summaryOfCompletionTableCsvData}
                        filename={`Summary_of_Completion_${moment().format('YYYY-MM-DD')}.csv`}
                        ref={summaryOfCompletionTableCsvButtonRef}
                        style={{ textDecoration: 'none', display: 'none' }}
                    />
                    <Button
                        variant='contained'
                        startIcon={<DownloadOutlined />}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            
                            const csvData = generateSummaryOfCompletionTableCsvData();

                            if (csvData.length > 0) {
                                setSummaryOfCompletionTableCsvData(csvData);
                                setTimeout(() => {
                                    setTriggerDownload(true);
                                }, 100);
                            } else {
                                props?.setSnackInfo("No data available to export", "warning");
                            }
                        }}
                        style={{
                            backgroundColor: "#355025",
                            color: "#FFF2EB",
                            padding: "0.4rem 2rem"
                        }}
                    >
                        Download CSV
                    </Button>
                </div>
                <div
                    className={classes.tablecontainer}
                    style={{ marginLeft: 25 }}
                >
                    <div className={classes.tableform}>
                        <div style={{ maxHeight: '700px', overflow: 'auto' }}>
                            <TableContainer component={Paper}
                                className={classes.table}
                                style={{ width: "100%" }}
                                classes={{ root: classes.customTableContainer }}>
                                <Table
                                    className={classes.table}
                                    stickyHeader
                                    aria-label="sticky table">
                                    <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ position: 'sticky', left: 0, zIndex: 9 }}>
                                                Project Completion Month
                                            </StyledTableCell>
                                            {projectCompetionData?.map((el) => {
                                                return (
                                                    <StyledTableCell
                                                        style={{
                                                            zIndex: 2,
                                                            fontWeight: `${el?.locationDetail?.locationName ===
                                                                "Grand Total"
                                                                ? "700"
                                                                : ""
                                                                }`,
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        {el?.locationDetail?.locationName}
                                                    </StyledTableCell>
                                                );
                                            })}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableHead style={{ position: 'sticky', top: 0 }}>
                                        {projectCompetionData[0]?.monthlyData?.map(
                                            (el, i) => {
                                                return (
                                                    <StyledTableRow key={i}>
                                                        <StyledTableCell
                                                            style={{
                                                                fontWeight: `${el?.mmyyyy === "Grand Total"
                                                                    ? "700"
                                                                    : ""
                                                                    }`,
                                                                textAlign: "center"
                                                            }}
                                                            component="th"
                                                        >
                                                            {el?.mmyyyy === "Grand Total" ? el?.mmyyyy : `${el?.mmyyyy.slice(0, 3)}-${el?.mmyyyy.slice(-2)}`}
                                                        </StyledTableCell>
                                                        {projectCompetionData.map((data, j) => {
                                                            return (
                                                                <StyledTableCell
                                                                    style={{
                                                                        zIndex: 1,
                                                                        background: "white",
                                                                        color: "black",
                                                                        fontWeight: `${el?.mmyyyy === "Grand Total" ||
                                                                            data?.locationDetail
                                                                                ?.locationName === "Grand Total"
                                                                            ? "700"
                                                                            : ""
                                                                            }`,
                                                                    }}
                                                                    className={classes.tableCell}
                                                                    component="th"
                                                                    onClick={() => {
                                                                        showDetailedModalHandler(
                                                                            data?.monthlyData[i].data,
                                                                            "Summary of Completion" +
                                                                            " | " +
                                                                            data?.monthlyData[i].mmyyyy
                                                                        );
                                                                    }}
                                                                >
                                                                    {data?.monthlyData[i]?.value}
                                                                </StyledTableCell>
                                                            );
                                                        })}
                                                    </StyledTableRow>
                                                );
                                            }
                                        )}
                                    </TableHead>
                                </Table>
                            </TableContainer>

                        </div>
                    </div>
                </div>
            </Fragment>
            <Modal
                title={title}
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename={title.replace("|", "-") + ".csv"}
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(null)}
                        style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
                        variant="contained"
                    >
                        Download CSV
                    </Button>
                </div>

                {detailDataArray && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 450 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Stage</StyledTableCell>
                                    <StyledTableCell>Department</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Experience Center</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Design Sign-Off Date</StyledTableCell>
                                    <StyledTableCell>Material Delivery Date</StyledTableCell>
                                    <StyledTableCell>Actual Completion Date</StyledTableCell>
                                    {ShowDesignSignOffRevokeDate && <StyledTableCell>Unique Lead ID</StyledTableCell>}
                                    {ShowDesignSignOffRevokeDate && <StyledTableCell>Design Sign-off HOLD Revoke Date</StyledTableCell>}
                                    <StyledTableCell>Current stage</StyledTableCell>
                                    <StyledTableCell>MWP Completion Date</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {detailDataArray?.map((data, i) => {
                                    return (
                                        <StyledTableRow key={i}>
                                            <StyledTableCell component="th">{i + 1}</StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {/* {data?.erpProjectNo || "N/A"} */}
                                                {
                                                    data.erpProjectNo ?
                                                        <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data.erpProjectNo}</Link> :
                                                        'NA'
                                                }
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {/* {data?.lead_no} */}
                                                {
                                                    data.lead_no ?
                                                        <Link to={`/project-logs/${data._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data.lead_no}</Link> :
                                                        'NA'
                                                }
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.currentStage}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.departmentName}
                                            </StyledTableCell>
                                            {/* <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.customerId?.name || "N/A"}
                                            </StyledTableCell> */}
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {(data?.grandTotal / 1.18)?.toLocaleString("en-IN", {
                                                    maximumFractionDigits: 2, // Maximum number of decimal places
                                                    style: "currency",
                                                    currency: "INR",
                                                })}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.cityName || "N/A"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.experienceCenterName || "N/A"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.leadWonDate
                                                    ? moment(data?.leadWonDate).utc().format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.customerDesignSignOffDate
                                                    ? moment(data?.customerDesignSignOffDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            {(value !== "Ops-1" && value !== "Ops-2 (Factory)") && <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.materialDispatchedDate
                                                    ? moment(data?.materialDispatchedDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>}
                                            {(value !== "Ops-1" && value !== "Ops-2 (Factory)" && value !== "Ops-3 (Execution)") && <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.executionCompletionDate
                                                    ? moment(data?.executionCompletionDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>}
                                            {ShowDesignSignOffRevokeDate && <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.uniqueLeadNumber}
                                            </StyledTableCell>}
                                            {ShowDesignSignOffRevokeDate && <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.designSignoffRevokeDate
                                                    ? moment(data?.designSignoffRevokeDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>}
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.currentStage || "N/A"}
                                            </StyledTableCell>

                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.executionMWPDate
                                                    ? moment(data?.executionMWPDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </Fragment>
    );
};

export default connect(null, { setLoading })(SummaryOfCompletion);